import StudentModuleProgressData from './StudentModuleProgressData';

export default StudentModuleProgressData;
